import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'success' | 'warning' | 'danger' | 'info' | 'neutral' | 'primary' | 'secondary';
  size?: 'sm' | 'md';
  dot?: boolean;
  className?: string;
}
export function Badge({
  children,
  variant = 'neutral',
  size = 'md',
  dot = false,
  className = ''
}: BadgeProps) {
  const variants = {
    success: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
    warning: 'bg-amber-500/10 text-amber-400 border-amber-500/20',
    danger: 'bg-red-500/10 text-red-400 border-red-500/20',
    info: 'bg-blue-500/10 text-blue-400 border-blue-500/20',
    neutral: 'bg-slate-500/10 text-slate-400 border-slate-500/20',
    primary: 'bg-primary/10 text-primary-light border-primary/20',
    secondary: 'bg-secondary/10 text-secondary-light border-secondary/20'
  };
  const sizes = {
    sm: 'text-[10px] px-1.5 py-0.5',
    md: 'text-xs px-2.5 py-0.5'
  };
  return <span className={`
      inline-flex items-center font-medium rounded-full border
      ${variants[variant]} 
      ${sizes[size]}
      ${className}
    `} data-id="element-183">
      {dot && <span className={`mr-1.5 h-1.5 w-1.5 rounded-full bg-current opacity-75`} data-id="element-184" />}
      {children}
    </span>;
}